import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import Movies from "views/admin/movies";
import MovieDetails from "views/admin/movies/details";
import Animation from "views/admin/animation";
import AnimationDetails from "views/admin/animation/details";
import Series from "views/admin/series";
import SeriesDetails from "views/admin/series/details";
import Users from "views/admin/users";
import Vjs from "views/admin/vjs";
import Genres from "views/admin/genres";
import Chat from "views/admin/chat";
import Search from "views/admin/search";
import RTLDefault from "views/rtl/default";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock,
  MdMovie,
  MdAnimation,
  MdTv,
  MdPeople,
  MdCategory,
  MdMic,
} from "react-icons/md";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "Movies",
    layout: "/admin",
    path: "movies",
    icon: <MdMovie className="h-6 w-6" />,
    component: <Movies />,
    children: [
      {
        path: "movies/:id",
        component: <MovieDetails />
      }
    ]
  },
  {
    name: "Animation",
    layout: "/admin",
    path: "animation",
    icon: <MdAnimation className="h-6 w-6" />,
    component: <Animation />,
    children: [
      {
        path: "animation/:id",
        component: <AnimationDetails />
      }
    ]
  },
  {
    name: "Series",
    layout: "/admin",
    icon: <MdTv className="h-6 w-6" />,
    path: "series",
    component: <Series />,
    children: [
      {
        path: "series/:id",
        component: <SeriesDetails />
      }
    ]
  },
  {
    name: "Users",
    layout: "/admin",
    icon: <MdPeople className="h-6 w-6" />,
    path: "users",
    component: <Users />,
  },
  {
    name: "Video Jockeys",
    layout: "/admin",
    icon: <MdMic className="h-6 w-6" />,
    path: "vjs",
    component: <Vjs />,
  },
  {
    name: "Genres",
    layout: "/admin",
    icon: <MdCategory className="h-6 w-6" />,
    path: "genres",
    component: <Genres />,
  },
  {
    name: "AI Chat",
    layout: "/admin",
    path: "chat",
    component: <Chat />,
    hide: true,
  },
  {
    name: "Search",
    layout: "/admin",
    path: "search",
    component: <Search />,
    hide: true,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
    hide: true,
  },
  {
    name: "RTL Admin",
    layout: "/rtl",
    path: "rtl",
    icon: <MdHome className="h-6 w-6" />,
    component: <RTLDefault />,
    hide: true,
  },
];
export default routes;
